import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class StartHeaderInfoTask extends AbstractRequestTask {
    constructor(HKS = "") {
        super();

        this.HKS = HKS;
    }

    getHeaders() {
        return {};
    }

    getParams() {
        const params = super.getParams();
        const HKS = this.HKS || params.HKS;

        return {
            HKS,
            authpn: params.authpn,
            authpt: params.authpt,
            format: params.format,
            device_id: params.device_id,
            device_category: params.device_category,
            device_model: params.device_model,
            device_type: params.device_type,
            device_manufacturer: params.device_manufacturer,
            device_so: params.device_so,
            device_name: params.device_name
        };
    }

    getUrl() {
        return `${Device.getDevice().getConfig().akamai_mfwk}/services/user/startheaderinfo`;
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default StartHeaderInfoTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/StartHeaderInfoTask.js